import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ProjectFilters from "./website/project_listing/ProjectFilters";
import ProjectList from "./website/project_listing/ProjectList";
import CsrProjectsHeader from "./website/project_listing/CsrProjectsHeader";

const ProjectsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const typeFromUrl = searchParams.get("type") || "pending";

  const [filters, setFilters] = useState({
    status: typeFromUrl
  });

  useEffect(() => {
    setFilters((prev) => ({ ...prev, status: typeFromUrl }));
  }, [typeFromUrl]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setSearchParams(`?type=${newFilters.status || "pending"}`);
  };

   const [projectCount, setProjectCount] = useState(0);

  return (
    <>
        <CsrProjectsHeader projectCount={projectCount} />

      <div className="container-fluid bg-light py-4">
        <div className="container">
          <div className="row g-4">

            <div className="col-lg-3">
              <ProjectFilters onFilterChange={handleFilterChange} />
            </div>

            <div className="col-lg-9">
              <ProjectList filters={filters} onCountChange={setProjectCount} />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectsPage;
